import isNewConsumerApp from 'commons/isNewConsumerApp';
// eslint-disable-next-line import/no-unresolved
import useAdvancedSearchNextURL from './useAdvancedSearchNextURL';
import useSearchUrlQueryParams from '../../advanced-search/hooks/useSearchUrlQueryParams';

/**
 * A compatibility hook that branches between Next.js App Router and React Router DOM.
 * - For new consumer app (Next.js 13+): uses next/navigation hooks
 * - For legacy consumer app: uses react-router-dom hooks
 */
const useAdvancedSearchURL = isNewConsumerApp
  ? useAdvancedSearchNextURL
  : useSearchUrlQueryParams;

export default useAdvancedSearchURL;
